/* Globo owns searching/results. Adapt presentation and its Spanish empty state. */
(() => {
  if (window.__collinoSearchRecovery) return;
  window.__collinoSearchRecovery = true;
  let frame = 0;
  // Change separators only, never parse Globo pesos as Shopify cents.
  const localizeSearchPrice = (text) => text.replace(
    /\b\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?\b/g,
    (amount) => amount.replace(/,/g, ' ').replace('.', ',').replace(/ /g, '.')
  );
  const syncPrices = (popup) => {
    if (document.getElementById('collino-search-recovery-template')?.dataset.currency !== 'ARS') return;
    popup.querySelectorAll('.gl-card-pricing, .gl-list__item-price').forEach((price) => {
      const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = localizeSearchPrice(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  };
  const sync = () => {
    frame = 0;
    const template = document.getElementById('collino-search-recovery-template');
    document.querySelectorAll('.glFilter-search-popup').forEach((popup) => {
      syncPrices(popup);
      if (!template) return;
      const message = popup.querySelector('.gl-fullscreen-suggestions');
      const empty = message?.textContent.includes('Lo sentimos, no se encontró nada para');
      const existing = popup.querySelector('[data-search-recovery]');
      if (!empty) {
        existing?.remove();
        return;
      }
      if (!existing) message.after(template.content.cloneNode(true));
      // Autocomplete decorates every descendant anchor as an option. These
      // are category navigation links, outside the product result listbox.
      popup.querySelectorAll('[data-search-recovery] a').forEach((link) => {
        if (link.getAttribute('role') !== 'link') link.setAttribute('role', 'link');
        if (link.tabIndex !== 0) link.tabIndex = 0;
      });
    });
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const init = () => {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-search-retry]');
      if (!button) return;
      const popup = button.closest('.glFilter-search-popup');
      const input = popup?.querySelector('#gl-d-searchbox-input') || document.getElementById('header-search-input');
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', { key: 'Backspace', bubbles: true }));
      input.focus();
    });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
